<template>
    <EpharmaTemplate>
        <template #page_title> ACTIVITES DES UTILISATEURS </template>
        <template #page_counter>
            <i class="fa-solid fa-user mr-1"></i> {{ lines }}
        </template>
        <template #content>
            <div class="col-md-4 ml-auto mb-3">
               <searchByKeyword v-on:set-keyword-filter="searchLines" /> 
            </div>
            
            <AsdecodeTable :useSearch :key="key" :url="'/api/' + table" :columns="columns" :table="table" :newKeyWord="keyWord" v-on:set-total-records="updateLines">
                <template #action_btns=slotProps>
                    <button class="btn btn-sm btn-light" @click="openShowModal(slotProps.data)">
                        <i class="fa-solid fa-eye"></i>
                    </button>
                </template>
            </AsdecodeTable>
        </template>
    </EpharmaTemplate>
</template>

<script>
import { defineComponent, defineAsyncComponent } from 'vue';

const ShowActivityUtilisateur = defineAsyncComponent(() => import('./ShowActivityUtilisateur.vue'));
export default defineComponent({

    data() {
        return {
            lines: 0,
            table: 'activity_logs',
            columns: [
                {
                    key: 'fullname',
                    label: 'NOM ET PRÉNOM',
                    exportable: true
                },
                {
                    key: 'module',
                    label: 'Module',
                    exportable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    exportable: true
                },
                {
                    key: 'ip_address',
                    label: 'Adresse IP',
                    exportable: true
                },
                {
                    key: 'user_agent',
                    label: 'Agent',
                    exportable: true
                },
                {
                    key: 'created_at',
                    label: 'DERNIÈRE ACTIVITÉ',
                    format: 'datetime',
                    exportable: true
                },
            ],
            key: 1,
            keyWord: ''
        }
    },
    methods: {
        openShowModal(objData) {
            this.$dialog.open(ShowActivityUtilisateur, {
                props: {
                    header: objData.fullname,
                    style: {
                        width: '60vw',
                    },
                    modal: true
                },
                data: objData
            });
        },
        updateLines(nb_lines) {
            this.lines = nb_lines
        },
        searchLines(keyword) {
            this.keyWord = keyword
            this.key++
        }
    },

})
</script>